import React from 'react';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Box from '@mui/material/Box';

import { fun } from '../constants/fun';
import { itemData } from '../constants/pics'


export default function Fun() {
  return (
    <Card >
      <Typography variant="h5" component="div">
      Other things I do
      </Typography>
      <Typography>{fun.description}
      </Typography>
    <Box sx={{ width: '100%', height: '40%', overflowY: 'scroll' }}>
      <ImageList variant="masonry" cols={3} gap={8}>
        {itemData.map((item) => (
          <ImageListItem key={item.img}>
            <img
              srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
              src={`${item.img}?w=248&fit=crop&auto=format`}
              alt={item.title}
              loading="lazy"
            />
          </ImageListItem>
        ))}
      </ImageList>
    </Box>
    </Card>
  );
}
